// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"457":"6a7bd5f0","710":"770e1314","787":"a8a97044"}[chunkId] + ".chunk.js";
};